import styled, { css, keyframes } from 'styled-components';
import { FXSBtnCta, FXSBtnDefault, FXSBtnPhantom } from 'styles/button';
import { COLORS } from 'styles/colors';

import { PopupButton } from '@typeform/embed-react';

type ActiveNotificationsProps = {
	isActive?: boolean;
};

const Sidebar = css`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	height: max-content;
	margin-left: auto;
	background: ${COLORS.white};
`;

export const NotificationsBackdrop = styled.div<{
	isNotificationsModalOpened: boolean;
}>`
	position: fixed;
	top: 0;
	bottom: 0;
	left: ${({ isNotificationsModalOpened }) =>
		isNotificationsModalOpened ? '0' : '100%'};
	right: ${({ isNotificationsModalOpened }) =>
		isNotificationsModalOpened ? '0' : '-200%'};
	display: flex;
	justify-content: flex-start;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 1001;
	min-height: 100vh;
	height: 100%;
	overflow-y: auto;
	transition: all 0.3s ease-in-out;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
`;
export const NotificationsSidebar = styled.aside`
	${Sidebar};
	width: 288px;
	@media (min-width: 833px) {
		width: 640px;
	}
`;
export const NotificationsSidebarHeader = styled.div`
	position: sticky;
	top: 0;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem;
	background: ${COLORS.white};
	border-bottom: 1px solid ${COLORS.grey300};
`;
export const NotificationGreybox = styled.div<{ show?: boolean }>`
	display: ${(props) => (props.show ? 'flex' : 'none')};
	flex-direction: column;
	align-items: center;
	background-color: #e0e7ee;
	padding: 17px 24px;
	overflow: hidden;
	@media (min-width: 833px) {
		padding: 20px 24px;
		flex-direction: row;
	}
	svg {
		width: 177px;
		position: relative;
		bottom: -30px;
		margin-top: -20px;
		flex: 0 0 177px;
	}
`;
export const NotificationDescription = styled.p`
	color: #49494f;
	font-size: 16px;
	line-height: 20px;
	@media (min-width: 833px) {
		font-size: 20px;
		line-height: 24px;
	}
`;
export const NotificationCloseText = styled.button`
	font-weight: 700;
	font-size: 14px;
	line-height: 20px;
	color: #2a77f6;
	&,
	&:hover,
	&:active {
		background-color: transparent;
		border: 0;
	}
`;
export const NotificationsSidebarTitle = styled.h2`
	margin: 0;
	font-size: 16px;
	line-height: 20px;
	@media (min-width: 833px) {
		font-size: 22.4px;
		line-height: 26px;
	}
`;
export const CloseIcon = styled.div`
	position: initial;
	top: unset;
	right: unset;
	height: 24px;
	width: 24px !important;
	color: ${COLORS.dark};
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	@media (min-width: 833px) {
		position: absolute;
		top: 1.5rem;
		right: 1.5rem;
	}
`;
export const NotificationsModalBody = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 1.5rem;
	padding: 1.5rem 0;
	@media (min-width: 833px) {
		padding: 1.5rem 0 3rem;
		border-bottom: 1px solid ${COLORS.grey300};
	}
`;
export const NotificationModalAllOnWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-items: flex-end;
	margin-bottom: 1.75rem;
	@media (min-width: 833px) {
		margin-bottom: unset;
	}
`;
export const NotificationModalAllOnP = styled.p`
	flex: 1;
	margin-bottom: 0;
	margin-right: 40px;
	font-weight: 700;
	font-size: 12.8px;
	line-height: 17px;
	text-align: end;
`;
export const NotificationsModalRow = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	&:not(:last-of-type) {
		margin-bottom: 1.5rem;
	}
`;
export const NotificationModalIconWrapper = styled.div`
	align-self: flex-start;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 32px;
	width: 32px;
	margin-right: 12px;
	background: #fcf3e8;
	color: ${COLORS.orange_highlight_light_1};
	@media (min-width: 768px) {
		height: 64px;
		width: 64px;
		margin-right: 1rem;
	}
`;
export const NotificationModalIcon = styled.div`
	height: 24px;
	width: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20px;
	@media (min-width: 833px) {
		font-size: 24px;
	}
`;
export const NotificationModalDescription = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
	max-width: 144px;
	@media (min-width: 768px) {
		max-width: 428px;
	}
	& h3 {
		margin: 0;
		font-size: 16px;
		line-height: 20px;
	}
	& p {
		margin: 0;
		font-weight: 300;
		font-size: 14.72px;
		line-height: 20px;
	}
`;
export const NotificationsModalCheckbox = styled.div`
	margin-left: auto;
	padding-right: unset;
	@media (min-width: 768px) {
		padding-right: 12px;
	}
`;
export const NotificationModalSwitchWrapper = styled.div<ActiveNotificationsProps>`
	position: relative;
	height: 16px;
	width: 30px;
	background-color: ${({ isActive }) =>
		isActive ? `${COLORS.ui_blue}` : ` ${COLORS.grey500}`};
	border-radius: 9px;
	cursor: pointer;
`;
export const NotificationModalSwitchCircle = styled.div<ActiveNotificationsProps>`
	position: absolute;
	top: 1px;
	left: ${({ isActive }) => (isActive ? 'unset' : '1px')};
	right: ${({ isActive }) => (isActive ? '1px' : 'unset')};
	height: 14px;
	width: 14px;
	background: ${COLORS.white};
	border-radius: 50%;
`;
export const NotificationsModalSuggestions = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	padding: 24px 1.5rem;
	margin-bottom: 10px;
	@media (min-width: 833px) {
		flex-direction: row;
	}
`;
export const NotificationsModalSuggestionsP = styled.p`
	margin: 0 1rem 1rem;
	font-size: 14.72px;
	line-height: 20px;
	text-align: center;
	@media (min-width: 833px) {
		margin: 0;
		text-align: left;
	}
`;
export const NotificationsModalTypeformPopUpBtn = styled(PopupButton)`
	${FXSBtnDefault};
	width: 138px;
`;
const fade = keyframes`
0% {
  opacity: 0;
}
50% {
  opacity: 1;
}
100% {
  opacity: 0;
}
`;
export const NotificationsSnackbar = styled.div`
	position: absolute;
	top: -30px;
	left: 0;
	display: flex;
	align-items: center;
	height: 30px;
	width: 100%;
	padding: 5px 10px;
	background: ${COLORS.success};
	color: ${COLORS.white};
	animation: 3s ${fade} ease-in-out;
`;
export const NotificationIcon = styled.div`
	margin-right: 8px;
	color: inherit;
	display: flex;
	align-items: center;
	justify-content: center;
`;
export const NotificatiionSnackbarP = styled.p`
	margin: 0;
	font-size: 14.72px;
	line-height: 20px;
`;
export const NotificationsModalBtnWrapper = styled.div`
	position: sticky;
	bottom: 0;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 1.5rem;
	background: ${COLORS.white};
	&:before {
		content: '';
		position: absolute;
		top: -40px;
		left: 0;
		right: 0;
		height: 40px;
		width: 100%;
		background: linear-gradient(
			to top,
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 0) 100%
		);
	}
`;
export const NotificationsModalBtnSave = styled.button`
	${FXSBtnCta};
	width: 115px;
	@media (min-width: 833px) {
		width: 156px;
	}
	&:hover {
		background: #e99f49;
		border: 1px solid #e4871b;
	}
	&:active {
		background: #e99f49;
		border: 1px solid #b66c16;
	}
	&[disabled] {
		background-color: #dddedf;
		color: #fff;
		border: 1px solid #dddedf;
		cursor: not-allowed;
	}
`;
export const NotificationsModalBtnReset = styled.button`
	${FXSBtnPhantom};
	width: 115px;
	background: ${COLORS.white};
	border: 1px solid ${COLORS.dark};
	color: ${COLORS.dark};
	@media (min-width: 833px) {
		width: 156px;
	}
	&:hover {
		background: #dddedf;
	}
	&:active {
		background: #1b1c23;
		color: white;
	}
	&[disabled] {
		background-color: #dddedf;
		color: #fff;
		border: 1px solid #dddedf;
	}
`;
